module.exports = __webpack_public_path__ + "static/media/hse.62b40d2a.png";